import React from "react";
import styles from "./main.module.css";
import Footer from "../../components/footer/footer";
import Menu from "../../components/main/menu";
import StarContainer from "../../components/star-container/star-container";
import { useSelector } from "react-redux";
import { LOCALES } from "../../constants";

export default function Main() {
    const lang = useSelector((state) => state.lang.value);

    return (
        <div id="container">
            <StarContainer />
            <a href="https://starsavior.com/kr" className={styles["logo-container"]} target="_blank">
                <img className={styles["logo"]} src={`${process.env.PUBLIC_URL}/images/index/logo.png`} />
            </a>
            <div className={styles["main"]}>
                <div className={styles["splash-container"]}>
                    <img src={`${process.env.PUBLIC_URL}/images/index/title.png`} className={styles["splash-image"]} />
                    <div className={styles["title"]}>{lang === LOCALES.KO ? "스타 세이비어 DB" : "Star Savior DB"}</div>
                </div>
                <div className={styles["menus"]}>
                    <Menu to={"arcana"} />
                    <Menu to={"savior"} />
                    <Menu to={"journey"} />
                    {/* <Menu to={"deck"} /> */}
                    <Menu to={"schedule"} />
                    <Menu to={"gacha"} />
                    <Menu to={"item"} />
                    <Menu to={"monster"} />
                    <Menu to={"potential"} />
                    {/* <Menu to={"music"} /> */}
                    <Menu to={"wallpaper"} />
                    <Menu to={"simulator/savior"} />
                </div>
                <Footer />
            </div>
        </div>
    );
}
